import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar as CalendarIcon } from "lucide-react";
import ReactMarkdown from "react-markdown";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";

export default function BlogPost() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [notFound, setNotFound] = useState(false);
    useEffect(() => {
        api.get(`/blog/${slug}`)
            .then((r) => setPost(r.data))
            .catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) {
        return (
            <div className="bg-[#FDFAF5] min-h-screen">
                <Navbar />
                <div className="max-w-3xl mx-auto px-6 py-40 text-center">
                    <h1 className="font-serif text-4xl text-[#0D1B1A]">
                        Post not found.
                    </h1>
                    <Link
                        to="/blog"
                        className="mt-6 inline-flex items-center gap-2 text-[#1A5C53] hover:text-[#13423B]"
                    >
                        <ArrowLeft size={16} /> Back to blog
                    </Link>
                </div>
                <Footer />
            </div>
        );
    }

    if (!post) {
        return (
            <div className="bg-[#FDFAF5] min-h-screen flex items-center justify-center">
                <p className="text-[#758684]">Loading…</p>
            </div>
        );
    }

    return (
        <div className="bg-[#FDFAF5] min-h-screen">
            <Navbar />

            <article
                data-testid="blog-article"
                className="pt-28 md:pt-36 pb-20"
            >
                <div className="max-w-3xl mx-auto px-6 md:px-12">
                    <Link
                        to="/blog"
                        className="inline-flex items-center gap-2 text-sm text-[#4A5A58] hover:text-[#1A5C53]"
                    >
                        <ArrowLeft size={14} /> All essays
                    </Link>
                    <div className="mt-6 flex items-center gap-3 text-xs text-[#758684]">
                        <CalendarIcon size={13} />
                        {new Date(post.created_at).toLocaleDateString("en-IN", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        })}
                        {post.tags?.map((t) => (
                            <span
                                key={t}
                                className="bg-[#F3EFE9] text-[#1A5C53] px-2 py-0.5 rounded-full"
                            >
                                {t}
                            </span>
                        ))}
                    </div>
                    <h1 className="font-serif text-4xl md:text-6xl text-[#0D1B1A] leading-[1.05] mt-5">
                        {post.title}
                    </h1>
                    <p className="mt-6 text-xl text-[#4A5A58] font-serif italic">
                        {post.excerpt}
                    </p>
                </div>

                {post.cover_image_url && (
                    <div className="max-w-5xl mx-auto px-6 md:px-12 mt-12">
                        <img
                            src={post.cover_image_url}
                            alt={post.title}
                            className="w-full aspect-[16/9] object-cover rounded-2xl border border-[#E6DFD3]"
                        />
                    </div>
                )}

                <div className="max-w-3xl mx-auto px-6 md:px-12 mt-12">
                    <div className="prose prose-lg max-w-none font-serif text-[#0D1B1A] leading-relaxed prose-headings:font-serif prose-headings:text-[#0D1B1A] prose-p:text-[#2A3634] prose-a:text-[#1A5C53] prose-strong:text-[#0D1B1A] prose-blockquote:border-l-[#D4944C] prose-blockquote:text-[#4A5A58] prose-blockquote:italic">
                        <ReactMarkdown>{post.content}</ReactMarkdown>
                    </div>

                    <div className="mt-16 pt-10 border-t border-[#E6DFD3]">
                        <div className="bg-[#0D1B1A] text-white rounded-2xl p-8 md:p-10 text-center">
                            <h3 className="font-serif text-3xl md:text-4xl">
                                Ready to turn insight into action?
                            </h3>
                            <p className="mt-3 text-[#9FB1AE]">
                                A one-time payment, a confidential questionnaire, and a real roadmap. Start with Disha for ₹969.
                            </p>
                            <Link
                                to="/questionnaire/disha"
                                data-testid="blog-cta-book"
                                className="mt-6 inline-block bg-[#D4944C] text-[#0D1B1A] hover:bg-[#E8B870] rounded-full px-7 py-3 font-medium"
                            >
                                Start with Disha — ₹969
                            </Link>
                        </div>
                    </div>
                </div>
            </article>

            <Footer />
        </div>
    );
}
